import React from 'react';
function GapHorizontal({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M21.005 21.005V20.205C21.005 19.0849 21.005 18.5248 20.787 18.097C20.5953 17.7207 20.2893 17.4147 19.913 17.223C19.4852 17.005 18.9251 17.005 17.805 17.005H6.20501C5.0849 17.005 4.52485 17.005 4.09702 17.223C3.7207 17.4147 3.41474 17.7207 3.22299 18.097C3.005 18.5248 3.005 19.0849 3.005 20.205L3.005 21.005M21.005 3.005V3.805C21.005 4.92511 21.005 5.48516 20.787 5.91299C20.5953 6.28931 20.2893 6.59527 19.913 6.78702C19.4852 7.005 18.9251 7.005 17.805 7.005L6.205 7.005C5.0849 7.005 4.52485 7.005 4.09702 6.78702C3.7207 6.59527 3.41474 6.28931 3.22299 5.91299C3.005 5.48516 3.005 4.92511 3.005 3.80501V3.005M17.51 12L6.01001 12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default GapHorizontal;
